import type { MailboxInfo } from 'owa-client-types';
import { isMessageFileMailboxInfo } from 'owa-client-types/lib/MessageFileMailboxInfo';
import isBusiness from 'owa-session-store/lib/utils/isBusiness';
import { isTeamsChatPolicyEnabled } from 'owa-teams-policies-store/lib/selectors/isTeamsChatPolicyEnabled';
import { isCapabilityEnabled } from 'owa-capabilities';
import { chatIntegrationCapability } from 'owa-capabilities-definitions/lib/chatIntegrationCapability';
import { isFeatureEnabled } from 'owa-feature-flags';
import { getModuleContextMailboxInfo } from 'owa-module-context-mailboxinfo';

export function isTeamsChatEnabled(mailboxInfo: MailboxInfo): boolean {
    // For MSG files, use the global module context mailboxInfo for capability/business checks
    const effectiveMailboxInfo =
        isFeatureEnabled('mon-msg-local-parser') && isMessageFileMailboxInfo(mailboxInfo)
            ? getModuleContextMailboxInfo()
            : mailboxInfo;

    return (
        isCapabilityEnabled(chatIntegrationCapability, effectiveMailboxInfo) &&
        isBusiness(effectiveMailboxInfo) &&
        isTeamsChatPolicyEnabled()
    );
}
